import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';

/**
 * V2 dùng canonical route `/conversation`. Giữ `/app/conversation` như một
 * compatibility entry point cho link cũ từ POS/FE13, rồi chuẩn hóa ngay trên
 * client và bảo toàn toàn bộ query params/fragment.
 *
 * V1 có bundle/router riêng và sẽ tự xử lý route ngược ở codebase V1; V2
 * không được giữ lại `/app/conversation` dù request còn `layoutUI=v1`, vì
 * route đó không có component V2 và sẽ dẫn đến trang 404.
 */
@Injectable({providedIn: 'root'})
export class LegacyAppConversationRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): UrlTree {
    const source = this.router.parseUrl(state.url);
    return this.router.createUrlTree(['/conversation'], {
      queryParams: source.queryParams,
      fragment: source.fragment || undefined,
    });
  }
}
